module.exports = __webpack_public_path__ + "static/img/yinliao.65193af.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/yinliao.png
// module id = eRUO
// module chunks = 4